module.exports = __webpack_public_path__ + "media/work.fdd8d891.mp4";